/**
 * English: Load chat transcript history from chat-api-service (Redis-backed).
 * Thai: โหลดประวัติแชทจาก chat-api-service
 */
import { useCallback } from 'react';
import { useApi } from './useApi';
import { ENDPOINTS } from '../config/api';
import type { ChatHistoryResponse } from '../types';

interface UseChatResult {
  loadChatHistory: (conversationId: string, limit?: number) => Promise<ChatHistoryResponse>;
}

export function useChat(): UseChatResult {
  const { get } = useApi();

  const loadChatHistory = useCallback(
    async (conversationId: string, limit?: number): Promise<ChatHistoryResponse> => {
      const params: Record<string, string> = { conversation_id: conversationId };
      if (limit != null) params.limit = String(limit);
      const data = await get(ENDPOINTS.chatHistory, params) as ChatHistoryResponse;
      return {
        conversation_id: data.conversation_id,
        messages: Array.isArray(data.messages) ? data.messages : [],
      };
    },
    [get],
  );

  return { loadChatHistory };
}
